import styled, { css } from 'styled-components';
import { customMedia } from 'styles/utils';

import Icon from 'components/Icon';
import Button from 'components/Button';
import { themes } from 'styles/themes/wikifactoryNew';

const TRIANGLE_SIZE = 3;

export const NavCubeStyled = styled.nav`
  pointer-events: auto;
  height: ${props => Math.max(props.height, 28)}px;
  right: ${props => props.right ?? 0}px;
  top: ${props => `${props.top ?? 0}px`};
  position: absolute;
  display: flex;
  z-index: 10;
  border-right-width: 0;
  flex-direction: column;
  background: ${props => props.background ?? props.theme.color.wfWhite};

  ${customMedia.lessThan('medium')`
    display: none;
  `};
`;

export const StdViewWrapper = styled.nav`
  position: absolute;
  right: 1.75rem;
  bottom: ${prop => prop.height - 10}px;
  width: ${prop => prop.width - 6}px;
  height: 22px;
  line-height: 18px;
  text-align: center;
  text-transform: uppercase;
  font-size: 13px;
  padding: 1px 0.5rem;
  color: ${props => props.theme.color.wfGrey500};
`;

const getButtonStyledColor = props => {
  const { disabled, theme, highligthed } = props;

  if (disabled) {
    return theme.color.wfGrey600;
  }

  if (highligthed) {
    return theme.color.wfBlue;
  }

  return theme.color.wfBlack;
};

export const ButtonStyled = styled(Button)`
  padding: ${props =>
    `0.25rem ${props.hasDropdown || props.hasPadding ? '0.25rem' : '0'}`};
  &:last-of-type {
    margin-right: 3px;
  }

  color: ${props => getButtonStyledColor(props)};
  background-color: ${props =>
    props.active ? themes.color.wfGrey100 : 'transparent'};

  svg {
    width: 1.2rem;
    height: 1.2rem;
  }

  position: relative;
  ${props =>
    props.hasDropdown
      ? css`
          &::after {
            content: '';
            width: 0;
            height: 0;
            border: ${TRIANGLE_SIZE}px solid transparent;
            border-top: ${TRIANGLE_SIZE}px solid
              ${props => props.theme.color.wfGrey900};
            position: absolute;
            bottom: 0;
            right: 0;
            transform: rotate(-45deg);
          }
        `
      : `
      margin: 0px 0.15rem;
      &:first-of-type {
        margin-left: 5px;
      }
    `}

  &:hover {
    color: ${props => props.theme.color.wfBlue};
    background-color: ${props =>
      props.active ? props.theme.color.wfGrey200 : 'transparent'};
  }

  ${props =>
    props.isAxis &&
    css`
      background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCEtLSBHZW5lcmF0b3I6IEdyYXZpdC5pbyAtLT48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHN0eWxlPSJpc29sYXRpb246aXNvbGF0ZSIgdmlld0JveD0iMCAwIDQwIDQwIiB3aWR0aD0iNDBwdCIgaGVpZ2h0PSI0MHB0Ij48ZGVmcz48Y2xpcFBhdGggaWQ9Il9jbGlwUGF0aF9abDRjRVBCQnNwTE5EVU5MTml5UkNkbjZKTmxGVVVrVSI+PHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIi8+PC9jbGlwUGF0aD48L2RlZnM+PGcgY2xpcC1wYXRoPSJ1cmwoI19jbGlwUGF0aF9abDRjRVBCQnNwTE5EVU5MTml5UkNkbjZKTmxGVVVrVSkiPjxwYXRoIGQ9IiBNIDMxLjg5NSAzNi4xODUgTCAyNi45MjcgMzYuMTg1IEwgMjYuOTI3IDM5IEwgMzYuNjI1IDM5IEwgMzYuNjI1IDI5LjE0OCBMIDMzLjg1NCAyOS4xNDggTCAzMy44NTQgMzQuMTk1IEwgMjEuMzg1IDIxLjUyNyBMIDE5Ljk5OSAyMi41NDcgTCAxOS45OTkgMjQuMTAxIEwgMzEuODk1IDM2LjE4NSBaICBNIDguMTA1IDM2LjE4NSBMIDEzLjA3MyAzNi4xODUgTCAxMy4wNzMgMzkgTCAzLjM3NSAzOSBMIDMuMzc1IDI5LjE0OCBMIDYuMTQ2IDI5LjE0OCBMIDYuMTQ2IDM0LjE5NSBMIDE4LjYxNSAyMS41MjcgTCAxOS45OTkgMjIuNTQ3IEwgMTkuOTk5IDI0LjEwMSBMIDguMTA1IDM2LjE4NSBaICBNIDE4LjYxMyAxMi4yNiBMIDE4LjYxMyAyMS41MjcgTCAxOS45OTkgMjIuNTQ3IEwgMjEuMzg1IDIxLjUyNyBMIDIxLjM4NSAxMi4yNiBMIDIxLjM4NSA2LjYyOSBMIDIxLjM4NSA2LjM4NyBMIDI0Ljk2NyAxMC4wMjYgTCAyNi45MjcgOC4wMzYgTCAxOS45OTkgMSBMIDEzLjA3MyA4LjAzNiBMIDE1LjAzMSAxMC4wMjYgTCAxOC42MTMgNi4zODcgTCAxOC42MTMgNi42MjkgTCAxOC42MTMgMTIuMjYgWiAiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZmlsbD0icmdiKDIwNSwyMDUsMjA1KSIvPjwvZz48L3N2Zz4=);
      background-repeat: no-repeat;
      background-size: 1.25rem;
      background-position: center;
    `}
`;

export const Separator = styled.div`
  position: relative;
  border-left: 1px solid ${themes.color.wfGrey100};
`;

export const NavCubeExpandStyled = styled.article`
  width: 100%;
`;

export const NodeStyled = styled.dl`
  font-size: 0.875rem;
`;

export const NodeTitle = styled.dt`
  display: flex;
  items-align: center;
  color: ${themes.color.wfBlack};
  line-height: ${props => props.theme.font.size.default};
  background-color: ${themes.color.wfGrey200};
  padding: 0.5rem;
`;

export const ActionNodeStyled = styled.dd`
  color: ${props => {
    return props.selected ? themes.color.wfBlue : themes.color.wfBlack;
  }};
  text-decoration: ${props => {
    return props.selected ? 'underline' : 'unset';
  }};
  user-select: none;
  padding: 0.5rem 0.5rem;
  margin-top: 0;
  &:hover {
    color: ${themes.color.wfBlue};
    cursor: pointer;
  }
  display: ${props => props.stacked && 'inline-flex;'};
  width: ${props =>
    props.stacked && props.stacked === 2
      ? 'calc(50%)'
      : props.stacked === 3
      ? 'calc(33%)'
      : ''};
`;

export const IconStyled = styled(Icon)`
  margin-right: ${props => props.theme.spacing.small};
  vertical-align: bottom;
`;
